"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToBudgetPlanMethod = exports.BudgetPlanMethodSchema = exports.BudgetPlanMethod = exports.castToBudgetPlanPolicy = exports.BudgetPlanPolicySchema = exports.BudgetPlanPolicy = exports.AllocationDetailsSchema = exports.PaymentProcessorRefSchema = exports.castToFundTransactionType = exports.FundTransactionTypeSchema = exports.FundTransactionType = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
const campaigns_1 = require("./campaigns");
var FundTransactionType;
(function (FundTransactionType) {
    FundTransactionType["SPENT"] = "SPENT";
    FundTransactionType["RECEIVED"] = "RECEIVED";
})(FundTransactionType = exports.FundTransactionType || (exports.FundTransactionType = {}));
exports.FundTransactionTypeSchema = (0, core_1.StringUnion)([FundTransactionType.SPENT, FundTransactionType.RECEIVED], {
    title: "Funding transfer type",
    description: "Whether money in the fund was spent or received",
});
exports.castToFundTransactionType = (0, cast_1.castToEnum)(FundTransactionType);
exports.PaymentProcessorRefSchema = typebox_1.Type.String();
exports.AllocationDetailsSchema = (0, core_1.StrictObject)({
    regions: typebox_1.Type.Array((0, core_1.StrictObject)({
        country: core_1.CountrySchema,
        purpose: campaigns_1.PurposeSchema,
        amount: core_1.MoneySchema,
        dailyAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    })),
});
var BudgetPlanPolicy;
(function (BudgetPlanPolicy) {
    // Budget Plan begins at the start date and end at the end date
    BudgetPlanPolicy["STOP_AT_END"] = "SE";
    // Budget Plan start at the start point and carries on (rollsover) at the end
    BudgetPlanPolicy["ROLLOVER_AT_END"] = "SR";
    // Budget Plan repeats the same value for every day, with no end date
    BudgetPlanPolicy["REPEATING"] = "RE";
})(BudgetPlanPolicy = exports.BudgetPlanPolicy || (exports.BudgetPlanPolicy = {}));
exports.BudgetPlanPolicySchema = (0, core_1.StringUnion)(Object.values(BudgetPlanPolicy), {
    title: "Budget Plan Policy",
});
exports.castToBudgetPlanPolicy = (0, cast_1.castToEnum)(BudgetPlanPolicy);
var BudgetPlanMethod;
(function (BudgetPlanMethod) {
    BudgetPlanMethod["ADJUST_DAILY"] = "AD";
    BudgetPlanMethod["FIXED_DAILY"] = "FD";
})(BudgetPlanMethod = exports.BudgetPlanMethod || (exports.BudgetPlanMethod = {}));
exports.BudgetPlanMethodSchema = (0, core_1.StringUnion)(Object.values(BudgetPlanMethod), {
    title: "Budget plan method",
});
exports.castToBudgetPlanMethod = (0, cast_1.castToEnum)(BudgetPlanMethod);
